import React from 'react'

interface SvgIconProps extends React.SVGProps<SVGSVGElement> {
  fill?: string
}

const SvgIcon: React.FC<SvgIconProps> = ({ fill = 'currentColor', ...props }) => {
  return (
    <svg {...props} fill={fill} xmlns="http://www.w3.org/2000/svg">
      <circle data-name="Ellipse 403" cx="23.5" cy="23.5" r="23.5" opacity={0.25} />
      <g data-name="PaddleIcon">
        <g data-name="Group 2517">
          <g data-name="Group 2516" transform="translate(15 15)">
            <path
              data-name="Path 1258"
              d="M1.076 330.116a.635.635 0 0 0 0 .9l.9.9a.635.635 0 0 0 .9 0l2.245-2.243-1.8-1.8z"
              transform="translate(-.89 -316.256)"
            />
            <path
              data-name="Path 1259"
              d="m95.315 193.363 1.8 1.8c.759-.759 2.086-.093 3.662.071l-5.534-5.534c.165 1.577.83 2.9.072 3.663z"
              transform="translate(-92.436 -182.192)"
            />
            <path
              data-name="Path 1260"
              d="M104.833 5.941c4.942-4.456 2.635-6.171.435-8.4-2.488-2.095-3.733-4.394-8.447.265l-.064.063a7.57 7.57 0 0 0-2.2 3.8l6.468 6.468a7.57 7.57 0 0 0 3.808-2.196z"
              transform="translate(-91.773 4.918)"
            />
            <circle data-name="Ellipse 387" cx="1.904" cy="1.904" r="1.904" transform="translate(11.056 12.972)" />
          </g>
        </g>
      </g>
    </svg>
  )
}

type PaddleIconFilledRoundedProps = SvgIconProps

export const PaddleIconFilledRounded: React.FC<PaddleIconFilledRoundedProps> = (props) => {
  return <SvgIcon {...props} viewBox="0 0 47 47" focusable="false" aria-hidden="true" />
}
